function CollapseView({ inventory, onView }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>Item Name:</strong> {inventory?.itemName}
        </p>
        <p className="mb-1">
          <strong>System Count:</strong> {inventory?.systemCount}
        </p>
        <p className="mb-1">
          <strong>Actual Count:</strong> {inventory?.actualCount || 0}
        </p>
        <p className="mb-1">
          <strong>UOM:</strong> {inventory?.uom?.name}
        </p>
        <p className="mb-1">
          <strong>Last Date Updated:</strong> {inventory?.lastAdjusted}
        </p>
        <p className="mb-1">
          <strong>Adjusted By:</strong> {inventory?.adjustedBy?.email}
        </p>
      </div>

      {/* <div className="d-flex gap-2">
        <button className="btn btn-success text-white" onClick={onView}>
          <i className="bi bi-eye me-2"></i> View
        </button>
      </div> */}
    </div>
  );
}

export default CollapseView;
